// Ish haqi — `xsib-hr` servisining `pay/` qismi bilan kontrakt.
//
//   GET    /api/hr/pay-components?activeOnly=            hr.salary.view
//   POST   /api/hr/pay-components                        hr.paycomponent.write
//   PUT    /api/hr/pay-components/{id}                   hr.paycomponent.write
//
//   GET    /api/hr/salaries?orgNodeId=&page=&size=       hr.salary.view
//   GET    /api/hr/persons/{id}/salary                   hr.salary.view
//   GET    /api/hr/persons/{id}/salary/history           hr.salary.view
//   POST   /api/hr/persons/{id}/salary                   hr.salary.write
//   POST   /api/hr/persons/{id}/salary/{cid}/stop?endOn= hr.salary.write
//   GET    /api/hr/persons/{id}/pay-events?limit=        hr.salary.view
//   POST   /api/hr/persons/{id}/pay-events               hr.salary.write
//
// =====================================================================
// ⚠️ 1-QOIDA — MAOSH SO'ROVI HUQUQSIZ YUBORILMAYDI
// =====================================================================
// `hr.salary.view` hech bir tizim roliga o'z-o'zidan tushmaydi
// (`V202608150700` va `xsib-hr/README.md`): o'n ikki huquqning
// birortasi ham `.read` bilan tugamaydi, ya'ni
// `identity.seed_system_roles()` ularni umuman ko'rmaydi.
//
// Panelda buning oqibati aniq: maosh maydonlari huquqsiz odamga
// «bo'sh» yoki `***` bo'lib ham KO'RINMAYDI — so'rovning O'ZI
// yuborilmaydi (`enabled: can('hr.salary.view')`). Sabab oddiy: 403
// javobi ham ma'lumot — u «bu odamda maosh bor» degan faktni
// tasdiqlaydi, va u tarmoq jurnalida qoladi.
//
// ⚠️ Uning o'rniga YOZILGAN SABAB va yetishmayotgan huquq KODI
// ko'rsatiladi (`hr.salaryNoPermission`) — administrator uni rol
// konstruktorida AYNAN shu nom bilan qidiradi. Quruq 403 banneri bu
// savolga javob bermasdi.
//
// =====================================================================
// ⚠️ 2-QOIDA — PUL MINOR BIRLIKDA, VALYUTA YONIDA
// =====================================================================
// Backend `long amountMinor` + `String currency` juftligini beradi
// (`PayItemView`, `PayEventView`) — `platform.api.Money` rekordi EMAS.
// Shuning uchun `moneySchema` bu yerda ishlatilmaydi va sxema aynan
// backend maydon nomlarini e'lon qiladi (`guards.mjs` §7 shu ikkalasini
// solishtiradi). Panel modelida esa ular BITTA `Money` ga yig'iladi —
// aks holda har chizilgan joyda valyutani qo'lda ulash kerak bo'lardi
// va bir joyda u unutilardi (`money.ts` javadoc'i).
//
// =====================================================================
// ⚠️ 3-QOIDA — USTAMA O'CHIRILMAYDI, DAVRI YOPILADI
// =====================================================================
// `PayItemDraft` manfiy yoki nol summani rad etadi va sababini o'zi
// yozadi: «Ustamani to'xtatish uchun davrni yoping». Ya'ni panelda ham
// O'CHIRISH tugmasi YO'Q — «To'xtatish» bor va u
// `POST /salary/{componentId}/stop` ga boradi. Tarix o'zgarmas
// (`hr.temporal_row_immutable()`).
//
// =====================================================================
// ⚠️ 4-QOIDA — XODIM ISMI JAVOBNING O'ZIDA KELADI, ALOHIDA SO'RALMAYDI
// =====================================================================
// `PayItemView` da `fullName` BOR va u qo'shni ikki ro'yxatdagi bilan
// AYNAN bir xil nom, tur va joyda (`PayrollLineView.fullName`,
// `LeaveRequestView.fullName`). Manba: `PayItemRepository#COLUMNS`
// `p.full_name` ni tanlaydi, ya'ni uchala o'qish yo'li ham
// (`history`, `openForPerson`, `searchOpen`) ismni qaytaradi.
//
// ⚠️ ILGARI BUNDAY EMAS EDI va panel ismni `GET /api/hr/persons` dan
// IKKINCHI so'rov bilan olardi. O'sha yamoq 2026-08-14 da OLIB
// TASHLANDI — nafaqat ortiqcha bo'lgani uchun:
//   · ro'yxat `ORDER BY p.full_name` bilan saralanadi, ya'ni saralash
//     tartibini beradigan ism bilan EKRANDAGI ism ikki xil manbadan
//     kelardi, ikkinchisi esa O'Z doirasiga bo'ysunardi;
//   · ikkinchi so'rov `hr.person.read` talab qilardi va ekranda
//     «ism uchun qo'shimcha huquq kerak» degan matn turardi — endi u
//     YOLG'ON bo'lardi, ya'ni matn ortiqcha emas, CHALG'ITUVCHI edi;
//   · bitta so'rov ko'pi bilan 200 xodim berardi va undan katta
//     tashkilotda qatorlar ismsiz qolardi.
//
// ⚠️ `personnelNo` esa bu yerda HAMON YO'Q (qo'shni ikkitasida bor).
// Ya'ni ro'yxatda tabel raqami ko'rsatilmaydi — uni ikkinchi so'rov
// bilan «to'ldirish» aynan yuqoridagi yamoqni qaytarish bo'lardi.

import { z } from 'zod'
import { api } from '@/shared/api/client'
import { operationResultSchema, type OperationResult } from '@/shared/api/operationResult'
import { instantSchema, uuidSchema } from '@/shared/api/schemas'
import { money, type Money } from '@/shared/lib/money'
import type { PageResult } from '@/shared/ui/table/DataTable'
import type { TableState } from '@/shared/ui/table/tableState'

/**
 * Pulning YO'NALISHI — `PayComponentKind` enumining nusxasi.
 *
 * ⚠️ `EARNING` qo'shiladi, `DEDUCTION` ayriladi. Ikkalasining ham
 * summasi HAR DOIM musbat: ishorani qism turi beradi, summa emas.
 * Aks holda «-50 000 li DEDUCTION» qo'shilib ketardi va nuqson faqat
 * vedomost jamida ko'rinardi.
 */
export const PAY_COMPONENT_KINDS = ['EARNING', 'DEDUCTION'] as const
export type PayComponentKind = (typeof PAY_COMPONENT_KINDS)[number]

/** `PayrollSource.ORIGIN_*` — vedomost satri qayerdan kelgani */
export const PAY_ORIGINS = ['RECURRING', 'ONE_OFF'] as const
export type PayOrigin = (typeof PAY_ORIGINS)[number]

/** `BankAccountDraft.ACCOUNT_NO_MIN` / `ACCOUNT_NO_MAX` */
export const ACCOUNT_NO_MIN = 4
export const ACCOUNT_NO_MAX = 64

// --- Ish haqi qismlari katalogi ----------------------------------------------

const payComponentSchema = z.object({
  id: uuidSchema,
  code: z.string(),
  name: z.string(),
  kind: z.enum(PAY_COMPONENT_KINDS),
  recurring: z.boolean(),
  /** ⚠️ ASOSIY oklad qismi — vedomostda birinchi turadi */
  base: z.boolean(),
  /** Tizim qismini o'chirib bo'lmaydi (katalogda tugma chizilmaydi) */
  system: z.boolean(),
  active: z.boolean(),
  createdAt: instantSchema.nullish(),
  updatedAt: instantSchema.nullish(),
})

export interface PayComponent {
  id: string
  code: string
  name: string
  kind: PayComponentKind
  recurring: boolean
  base: boolean
  system: boolean
  active: boolean
  createdAt: string | null
  updatedAt: string | null
}

function toPayComponent(raw: z.infer<typeof payComponentSchema>): PayComponent {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    kind: raw.kind,
    recurring: raw.recurring,
    base: raw.base,
    system: raw.system,
    active: raw.active,
    createdAt: raw.createdAt ?? null,
    updatedAt: raw.updatedAt ?? null,
  }
}

/** ⚠️ Eksport qilingan — `tests/hr-pay.mjs` uni haqiqiy javob shakli ustida yurgizadi */
export function parsePayComponent(raw: unknown): PayComponent {
  return toPayComponent(payComponentSchema.parse(raw))
}

export async function fetchPayComponents(activeOnly: boolean): Promise<readonly PayComponent[]> {
  const response = await api.get<unknown>('/api/hr/pay-components', { params: { activeOnly } })
  return z.array(payComponentSchema).parse(response.data).map(toPayComponent)
}

export interface PayComponentDraft {
  /** `^[A-Z][A-Z0-9_]{1,31}$` — `HrTextRules.JOB_TITLE_CODE` bilan bir xil shakl */
  code: string
  name: string
  kind: PayComponentKind
  /**
   * ⚠️ `true` — har oy takrorlanadi (oklad, doimiy ustama);
   * `false` — faqat bir martalik hodisa sifatida yoziladi (mukofot).
   * Bazadagi `hr.pay_item_guard()` takrorlanmaydigan qismga doimiy
   * ustama yozishni RAD ETADI.
   */
  recurring: boolean
  active: boolean
}

export async function createPayComponent(draft: PayComponentDraft): Promise<PayComponent> {
  const response = await api.post<unknown>('/api/hr/pay-components', draft)
  return toPayComponent(payComponentSchema.parse(response.data))
}

export async function updatePayComponent(
  id: string,
  draft: PayComponentDraft,
): Promise<PayComponent> {
  const response = await api.put<unknown>(`/api/hr/pay-components/${id}`, draft)
  return toPayComponent(payComponentSchema.parse(response.data))
}

// --- Doimiy qism (oklad, ustama) ---------------------------------------------

const payItemSchema = z.object({
  id: uuidSchema,
  personId: uuidSchema,
  /**
   * ⚠️ JOIN'dan keladi (`hr.person`), NUSXA emas — shakl qo'shni ikki
   * ro'yxat bilan bir xil (`payrollLineSchema`, `leaveRequestSchema`)
   */
  fullName: z.string().nullish(),
  componentId: uuidSchema,
  componentCode: z.string().nullish(),
  componentName: z.string().nullish(),
  kind: z.enum(PAY_COMPONENT_KINDS),
  amountMinor: z.number(),
  currency: z.string(),
  /** `LocalDate` — "YYYY-MM-DD", vaqt zonasi YO'Q */
  validFrom: z.string(),
  /** `null` = JORIY davr */
  validTo: z.string().nullish(),
  open: z.boolean(),
  reason: z.string().nullish(),
  changedBy: z.string().nullish(),
  createdAt: instantSchema.nullish(),
})

export interface PayItem {
  id: string
  personId: string
  fullName: string | null
  componentId: string
  componentCode: string | null
  componentName: string | null
  kind: PayComponentKind
  /** ⚠️ MINOR birlik + valyuta bitta qiymatda (`money.ts`) */
  amount: Money
  validFrom: string
  validTo: string | null
  open: boolean
  reason: string | null
  changedBy: string | null
  createdAt: string | null
}

function toPayItem(raw: z.infer<typeof payItemSchema>): PayItem {
  return {
    id: raw.id,
    personId: raw.personId,
    fullName: raw.fullName ?? null,
    componentId: raw.componentId,
    componentCode: raw.componentCode ?? null,
    componentName: raw.componentName ?? null,
    kind: raw.kind,
    amount: money(raw.amountMinor, raw.currency),
    validFrom: raw.validFrom,
    validTo: raw.validTo ?? null,
    open: raw.open,
    reason: raw.reason ?? null,
    changedBy: raw.changedBy ?? null,
    createdAt: raw.createdAt ?? null,
  }
}

export function parsePayItem(raw: unknown): PayItem {
  return toPayItem(payItemSchema.parse(raw))
}

export function parsePayItems(raw: unknown): readonly PayItem[] {
  return z.array(payItemSchema).parse(raw).map(toPayItem)
}

/** Joriy (ochiq) qismlar */
export async function fetchSalary(personId: string): Promise<readonly PayItem[]> {
  const response = await api.get<unknown>(`/api/hr/persons/${personId}/salary`)
  return parsePayItems(response.data)
}

/** Butun tarix — yopilgan davrlar bilan */
export async function fetchSalaryHistory(personId: string): Promise<readonly PayItem[]> {
  const response = await api.get<unknown>(`/api/hr/persons/${personId}/salary/history`)
  return parsePayItems(response.data)
}

const payItemPageSchema = z.object({
  rows: z.array(payItemSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
})

/** ⚠️ Eksport qilingan — `tests/hr-pay.mjs` uni haqiqiy javob shakli ustida yurgizadi */
export function parsePayItemPage(raw: unknown): PageResult<PayItem> {
  const parsed = payItemPageSchema.parse(raw)
  return { items: parsed.rows.map(toPayItem), total: parsed.total }
}

export interface SalaryFilter {
  /**
   * ⚠️ AYNAN shu tugundagilar — `SUBTREE` EMAS
   * (`SalaryController#list`, `PersonFilter.orgNodeId` bilan bir xil
   * izoh). «Filial va uning ostidagilar» — bu ko'rinish DOIRASI va u
   * tokendan keladi; bu esa oddiy filtr.
   */
  orgNodeId: string | null
}

/**
 * Tashkilot bo'ylab AMALDAGI maosh satrlari — «kim qancha oladi».
 *
 * ⚠️ Bir qator = bir XODIM emas, bir QISM. Okladi va ustamasi bor
 * xodim ro'yxatda IKKI marta chiqadi va bu to'g'ri: sahifa qismlarni
 * ko'rsatadi, jamni esa vedomost hisoblaydi. Panelda bu ochiq
 * yoziladi — aks holda operator qatorlarni sanab «xodimlar soni» deb
 * o'qirdi.
 */
export function fetchSalaryPage(
  filter: SalaryFilter,
): (state: TableState, signal: AbortSignal) => Promise<PageResult<PayItem>> {
  return async (state, signal) => {
    const response = await api.get<unknown>('/api/hr/salaries', {
      signal,
      params: {
        ...(filter.orgNodeId === null ? {} : { orgNodeId: filter.orgNodeId }),
        // Backend sahifani 0 dan sanaydi — `/api/hr/persons` bilan bir xil
        page: state.page - 1,
        size: state.pageSize,
      },
    })
    return parsePayItemPage(response.data)
  }
}

export interface PayItemDraft {
  componentId: string
  /** ⚠️ MINOR birlik, MUSBAT. Ishora qism turidan keladi. */
  amountMinor: number
  /** "YYYY-MM-DD" yoki `null` — server bugungi kunni qo'yadi */
  validFrom: string | null
  /** ⚠️ MAJBURIY — sababsiz tarix audit jurnalidan farq qilmaydi */
  reason: string
}

export async function setSalaryItem(personId: string, draft: PayItemDraft): Promise<PayItem> {
  const response = await api.post<unknown>(`/api/hr/persons/${personId}/salary`, draft)
  return toPayItem(payItemSchema.parse(response.data))
}

/**
 * Doimiy qismni to'xtatish — O'CHIRISH O'RNIDA.
 *
 * @param endOn oxirgi amal qiladigan kun ("YYYY-MM-DD"); `null` bo'lsa
 *              server bugungi kunni qo'yadi
 */
export async function stopSalaryItem(
  personId: string,
  componentId: string,
  endOn: string | null,
): Promise<OperationResult> {
  const response = await api.post<unknown>(
    `/api/hr/persons/${personId}/salary/${componentId}/stop`,
    null,
    { params: endOn === null ? {} : { endOn } },
  )
  return operationResultSchema.parse(response.data)
}

// --- Bir martalik hodisa (mukofot, avans, jarima) ----------------------------

const payEventSchema = z.object({
  id: uuidSchema,
  personId: uuidSchema,
  componentId: uuidSchema,
  componentCode: z.string().nullish(),
  componentName: z.string().nullish(),
  kind: z.enum(PAY_COMPONENT_KINDS),
  /** `LocalDate` */
  occurredOn: z.string(),
  amountMinor: z.number(),
  currency: z.string(),
  note: z.string().nullish(),
  /**
   * ⚠️ `true` — hodisa vedomostga TUSHGAN va endi band. Panel uni
   * o'zgartirish yo'lini ko'rsatmaydi: backendda ham bunday endpoint
   * yo'q (`PayrollGenerationIT` — «bir martalik to'lovning band
   * bo'lishi»).
   */
  settled: z.boolean(),
  payrollLineId: uuidSchema.nullish(),
  createdBy: z.string().nullish(),
  createdAt: instantSchema.nullish(),
})

export interface PayEvent {
  id: string
  personId: string
  componentId: string
  componentCode: string | null
  componentName: string | null
  kind: PayComponentKind
  occurredOn: string
  amount: Money
  note: string | null
  settled: boolean
  payrollLineId: string | null
  createdBy: string | null
  createdAt: string | null
}

function toPayEvent(raw: z.infer<typeof payEventSchema>): PayEvent {
  return {
    id: raw.id,
    personId: raw.personId,
    componentId: raw.componentId,
    componentCode: raw.componentCode ?? null,
    componentName: raw.componentName ?? null,
    kind: raw.kind,
    occurredOn: raw.occurredOn,
    amount: money(raw.amountMinor, raw.currency),
    note: raw.note ?? null,
    settled: raw.settled,
    payrollLineId: raw.payrollLineId ?? null,
    createdBy: raw.createdBy ?? null,
    createdAt: raw.createdAt ?? null,
  }
}

export function parsePayEvent(raw: unknown): PayEvent {
  return toPayEvent(payEventSchema.parse(raw))
}

export async function fetchPayEvents(
  personId: string,
  limit = 50,
): Promise<readonly PayEvent[]> {
  const response = await api.get<unknown>(`/api/hr/persons/${personId}/pay-events`, {
    params: { limit },
  })
  return z.array(payEventSchema).parse(response.data).map(toPayEvent)
}

export interface PayEventDraft {
  componentId: string
  /** "YYYY-MM-DD" */
  occurredOn: string
  /** MINOR birlik, MUSBAT */
  amountMinor: number
  note: string | null
}

export async function addPayEvent(personId: string, draft: PayEventDraft): Promise<PayEvent> {
  const response = await api.post<unknown>(`/api/hr/persons/${personId}/pay-events`, draft)
  return toPayEvent(payEventSchema.parse(response.data))
}

// --- Sof mantiq --------------------------------------------------------------

/**
 * Ochiq qismlardan «qo'lga tegadigan» summani hisoblaydi:
 * `EARNING` yig'indisi minus `DEDUCTION` yig'indisi.
 *
 * ⚠️ BU TAXMIN, VEDOMOST EMAS — va shuning uchun ekranda ham shunday
 * yoziladi. Haqiqiy hisob `payroll` da bo'ladi: u bir martalik
 * hodisalarni ham oladi, oy oxiridagi tayinlashga qaraydi va ishdan
 * bo'shaganni chiqarib tashlaydi (`PayrollGenerationIT`). Bu yerdagi
 * son faqat «hozir doimiy qanday qismlar bor» degan savolga javob
 * beradi.
 *
 * ⚠️ Turli valyutali qism bo'lsa `null` qaytadi, jimgina qo'shilmaydi:
 * `addMoney` ataylab istisno tashlaydi va uni kartochkada YIQILISHGA
 * aylantirish noto'g'ri bo'lardi. Baza ham buni rad etadi
 * (`hr.pay_item_guard()` valyutani tekshiradi), ya'ni bu holat amalda
 * faqat ma'lumot buzilganda chiqadi — va o'shanda son ko'rsatmagan
 * NOTO'G'RI son ko'rsatgandan yaxshiroq.
 */
export function netOfItems(items: readonly PayItem[]): Money | null {
  if (items.length === 0) return null
  const currency = items[0]?.amount.currency ?? ''
  let total = 0
  for (const item of items) {
    if (item.amount.currency !== currency) return null
    total += item.kind === 'EARNING' ? item.amount.amount : -item.amount.amount
  }
  return money(total, currency)
}

/**
 * Qism JORIYmi.
 *
 * ⚠️ Yagona mezon — server aytgan `open`. `validTo === null` bilan
 * solishtirish YETARLI EMAS: kelajakda boshlanadigan davr ham
 * `validTo` siz bo'ladi, lekin u hali amal qilmaydi. Server buni
 * sanaga qarab hisoblaydi va javobda aytadi.
 */
export function isOpenItem(item: PayItem): boolean {
  return item.open
}
